import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";

const ReportModal = ({ closeReportModal, isReportModalOpen, allDagNodes }) => {

  if (!isReportModalOpen) return null;

  const handleExportCurrentStateCSV = async () => {
    try {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      const response = await fetch(baseUrl + '/export_current_state_csv');

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'diagram_state.csv'; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=['"]?([^;\n]+)['"]?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error('Error fetching the CSV:', error);
    }
  }

  const handleExportIndividualNodeHistoryCSV = async () => {
    try {
      const dagNodeSelector = document.getElementById('dagNodeSelector');
      const selectedNodeId = dagNodeSelector.value;

      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      const response = await fetch(baseUrl + `/export_individual_node_history_csv?dag_node_name=${selectedNodeId}`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'diagram_state.csv'; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=['"]?([^;\n]+)['"]?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error('Error fetching the CSV:', error);
    }
  };

  const handleExportDiagramHistoryAtDatetimeCSV = async () => {
    try {
      const datetimeReportValue = document.getElementById('datetimeReportValue').value;
      // Convert datetime to UTC tiemzone
      const date = new Date(datetimeReportValue);
      const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      const response = await fetch(baseUrl + `/export_diagram_at_datetime_csv?datetime=${utcDate}`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'diagram_state.csv'; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=['"]?([^;\n]+)['"]?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error('Error fetching the CSV:', error);
    }
  };

  const exportDiagramHistory = async () => {
    try {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      const response = await fetch(baseUrl + `/export_diagram_history_csv`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      // Extract the filename from the Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'diagram_state.csv'; // Default filename
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*?=['"]?([^;\n]+)['"]?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }
      saveAs(blob, filename);
    } catch (error) {
      console.error('Error fetching the CSV:', error);
    }
  };

  return (
    <div className="modal fixed inset-0 flex items-center justify-center z-50">
      <div style={{ backgroundColor: '#f1f0f5', height: '90%', width: '60%' }} className="bg-white rounded-lg shadow-lg p-6 w-1/2 h-full flex flex-col justify-between">
        <div>
          <div className="flex justify-between">
            <h1 className="modal-title text-2xl font-semibold text-gray-800">Diagram Reports</h1>
            <div>
                <i className="bi bi-x-lg cursor-pointer" onClick={closeReportModal}></i>
            </div>
          </div>
          <div className="mt-8 flex justify-between">
            <button type="button" 
              onClick={() => handleExportCurrentStateCSV()} 
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">
              Export Diagram State as CSV
            </button>
          </div>
          <div className="mt-8 flex justify-between">
            <button type="button" 
              onClick={() => handleExportIndividualNodeHistoryCSV()} 
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">
              Export History for Individual Node as CSV
            </button>
            <label htmlFor="dagNode" className="font-semibold text-gray-700">Selected Node: </label>
            <select id="dagNodeSelector" name="dagNode" className="border border-gray-300 p-2 rounded">
                {allDagNodes?.map((node, index) => (
                    <option key={index} value={node.slug}>{node.name}</option>
                ))}
            </select>
          </div>
          <div className="mt-8 flex justify-between">
            <button type="button" 
              onClick={() => handleExportDiagramHistoryAtDatetimeCSV()} 
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">
              Export History for Diagram at Datetime as CSV
            </button>
            <label htmlFor="dagNode" className="font-semibold text-gray-700">Datetime for report: </label>
            <input type="datetime-local" id="datetimeReportValue" name="datetimeReportValue" className="border border-gray-300 p-2 rounded" />
          </div>
          <div className="mt-8 flex justify-between">
            <button type="button" 
              onClick={() => exportDiagramHistory()} 
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mr-2">
              Export Diagram History
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;